var _g, _circle, _circle2, _ellipse, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150pt",
    height: "150pt",
    viewBox: "0 0 150.000000 150.000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75.38,
    fill: "#fff",
    style: {
      paintOrder: "stroke markers fill"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 .76994 148.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m595 1323c-96-13-205-59-230-97-15-23-12-33 69-218 74-168 86-203 92-269 4-52 3-83-6-99-12-22-15-22-94-14-114 11-146 9-197-13l-44-20 70-3c39-2 82-3 97-4 14-1 24-4 23-7-2-3 13-13 33-22s60-37 88-61c28-25 55-42 59-38 3 4 5 0 3-8s3-14 9-13c7 2 12 0 12-5-3-20 3-23 19-11 15 13 16 12 4-3-11-14-7-25 35-80 26-35 52-66 56-69 5-3 9-9 8-12-1-21 23-66 32-60 6 4 7 1 3-6-5-7-2-25 4-41 12-30 12-29 68 83 31 61 55 116 54 120-1 5 2 6 6 3 5-3 17 3 27 14s15 20 11 20c-3 0 29 32 71 71 110 100 167 127 280 131 45 1 50 3 35 13-37 27-94 35-163 24-37-6-86-8-110-6l-43 4 3 54c1 30 4 63 7 74 4 16 3 17-5 5-7-9-11-10-11-3 0 6 4 14 9 17s11 16 15 29c3 13 42 103 86 200s80 188 80 200c0 73-180 128-408 126-70-1-140-4-157-6zm54-253c58-6 139-8 180-5 81 7 205 32 232 46 30 15 27-2-11-83-42-89-80-124-99-91-9 16-10 16-11-3 0-12-11-26-25-34-33-18-78-77-69-92 4-6 3-8-3-5-5 4-23-7-38-23-36-38-68-38-101 0-15 16-30 27-35 25-4-3-11 0-15 6-4 8-3 9 4 5s12-3 12 2c0 14-72 82-87 82-7 0-13 11-13 28-1 23-2 24-11 10-19-34-53-3-91 87-20 46-34 86-32 88s28-4 57-14c28-10 99-23 156-29zm-51-213c9 1 11 0 5-3-10-4-10-11-2-25 5-11 14-17 19-14 6 4 7-1 3-11-5-13-3-15 7-9 8 5 11 4 6-3-3-5 7-39 22-74 42-91 50-115 67-193 9-38 18-79 21-90 4-15 0-12-13 8-11 15-23 24-28 20-4-5-5-2 0 5 9 17-24 94-38 85-6-4-7-1-3 6 10 15-13 73-25 65-5-3-6 3-2 12 4 12 3 15-5 10-8-4-10-2-6 7 3 8-8 41-24 73-16 33-27 65-25 72 3 7-4 23-15 35s-23 32-27 45c-3 12-11 20-16 17-5-4-6 2-2 11 5 15 11 12 35-17 16-19 37-33 46-32zm402 60c0-10-35-74-47-85-7-7-13-21-13-30 0-13-143-352-157-371-21-30 5 104 46 238 11 35 17 69 14 75s-2 8 2 3c10-8 56 68 51 86-1 7-1 9 1 5 2-3 22 14 45 38 35 37 58 54 58 41zm-200-172c0-2-10-9-22-15-22-11-22-10-4 4 21 17 26 19 26 11zm91-118c-10-9-11-8-5 6 3 10 9 15 12 12s0-11-7-18zm-246-94c21-49 51-115 66-147 16-33 29-67 29-77 0-24-19-34-26-14-6 14-9 14-16 3-8-10-9-9-5 3 7 21-57 191-68 181-4-4-5-2-1 5s-2 40-14 74c-23 71-23 72-11 65 5-3 25-45 46-93zm226-49c-61-171-80-209-93-196-10 10-10 20 0 44 6 17 9 36 5 42-3 6-3 8 2 4 9-9 14 0 75 136 24 54 46 94 47 89 2-5-14-59-36-119zm33-32c3-5-1-9-9-9s-12 4-9 9c3 4 7 8 9 8s6-4 9-8zm-53-85c-10-9-11-8-5 6 3 10 9 15 12 12s0-11-7-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m729 927c-17-9-25-22-27-45-4-40 12-62 45-62 43 0 63 18 63 55 0 28-6 37-28 49-23 12-33 12-53 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387 762c-24-26-21-68 5-86 26-19 52-21 42-4-4 7-3 8 5 4 18-12 41 13 41 44 0 52-60 79-93 42z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 129.73,
    cy: 90.714,
    r: 0,
    stroke: "#ff4242",
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.73,
    cy: 90.714,
    r: 0,
    stroke: "#ff4242",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .084434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.1683)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.168,
    cy: 28.036,
    rx: 39.794,
    ry: 13.028,
    fill: "#0087dc",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "m113.72 28.465-37.879 100.54-37.208-100.43",
    fill: "none",
    stroke: "#0087dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.35,
    style: {
      paintOrder: "stroke markers fill"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.23 -14.948)",
    fill: "#1b2d4f"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 150)",
    d: "m916.52 787.07c-11-11-20-29-20-40 0-26 34-60 60-60 24 0 60 37 60 62 0 24-35 58-60 58-11 0-29-9-40-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.23 149.77s3.5387-43.033 8.2587-54.643c7.9283-19.502 23.532-26.943 21.996-28.463s-12.147 4.5245-17.126 8.0365c-4.9794 3.512-12.75 13.036-12.75 13.036s-6.9947-9.1935-11.721-12.521-14.903-8.0876-16.089-6.9625c-2.4573 2.3326 6.5275 4.02 18.527 24.746 5.8589 10.12 8.9041 56.771 8.9041 56.771z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.76502 -1.4923)",
    fill: "#f9b233"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 150)",
    d: "m1040 760c-11-11-20-29-20-40 0-26 34-60 60-60 24 0 60 37 60 62 0 24-35 58-60 58-11 0-29-9-40-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.765 136.32s8.4692-21.948 24.428-34.988c14.066-11.493 26.103-8.6744 29.805-10.812 3.9674-2.1448-17.912-4.7474-26.393-4.1576-3.6426-4.5026-5.0024-30.541-9.9003-31.209 7.0834 23.469-12.93 60.156-17.941 81.166z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 150.77 -1.4923)",
    fill: "#b61823"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 150)",
    d: "m1040 760c-11-11-20-29-20-40 0-26 34-60 60-60 24 0 60 37 60 62 0 24-35 58-60 58-11 0-29-9-40-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.765 136.32s8.4692-21.948 24.428-34.988c14.066-11.493 26.103-8.6744 29.805-10.812 3.9674-2.1448-17.912-4.7474-26.393-4.1576-3.6426-4.5026-5.0024-30.541-9.9003-31.209 7.0834 23.469-12.93 60.156-17.941 81.166z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b48205858b8af2c6ab7c105f1c8b18b0.svg";
export { ForwardRef as ReactComponent };